import { atom, useAtom } from "jotai"
import useWindowDimensions from "../../src/hooks/useWindowDimensions"
import { tabletWidth } from "../../utils/enum/constants"

export const deviceTypeAtom = atom("")

export const useDeviceType = () => {
	const [deviceType] = useAtom(deviceTypeAtom)
	const { width } = useWindowDimensions()

	// Prefer the hook, but read innerWidth on first client render so a
	// resized desktop window does not flash the left rail before resize fires.
	const liveWidth =
		typeof width === "number"
			? width
			: typeof window !== "undefined"
				? window.innerWidth
				: undefined

	const isNarrowViewport =
		typeof liveWidth === "number" && liveWidth < tabletWidth
	const isMobile = deviceType === "Mobile" || isNarrowViewport
	const isTablet = !isMobile && deviceType === "Tablet"
	const isDesktop = !isMobile && !isTablet

	return { deviceType, isMobile, isTablet, isDesktop }
}
